import { FeedbackTopic } from '../../consts/feedback-topic.const'

export type FeedbackTopicValue = (typeof FeedbackTopic)[keyof typeof FeedbackTopic]

export type FeedbackTopicOption = {
  value: FeedbackTopicValue
  labelKey: string
}

export const FEEDBACK_TOPIC_OPTIONS: FeedbackTopicOption[] = [
  { value: FeedbackTopic.PRODUCT, labelKey: 'topics.product' },
  { value: FeedbackTopic.DEVELOPER_EXPERIENCE, labelKey: 'topics.developer-experience' },
  { value: FeedbackTopic.INTEGRATION_EXPERIENCE, labelKey: 'topics.integration-experience' },
  { value: FeedbackTopic.PERFORMANCE_RELIABILITY, labelKey: 'topics.performance-reliability' },
  { value: FeedbackTopic.DOCUMENTATION_LEARNING, labelKey: 'topics.documentation-learning' },
  { value: FeedbackTopic.FEATURE_REQUEST, labelKey: 'topics.feature-request' },
  { value: FeedbackTopic.BUG_REPORT, labelKey: 'topics.bug-report' },
  { value: FeedbackTopic.OTHER, labelKey: 'topics.other' },
]
